import styled from "styled-components"

export const DescriptionWrapper = styled.span`
  margin-left: 22px;
`

export const DisplayIconWrapper = styled.span`
  position: relative;
  width: 20px;
  > svg {
    position: absolute;
    bottom: 0;
  }
`
